"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Project/App Name APIs
 * API documentation for the backend services of Project/App Name
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.instanceOfPropertyAddressSuggestionsDto = instanceOfPropertyAddressSuggestionsDto;
exports.PropertyAddressSuggestionsDtoFromJSON = PropertyAddressSuggestionsDtoFromJSON;
exports.PropertyAddressSuggestionsDtoFromJSONTyped = PropertyAddressSuggestionsDtoFromJSONTyped;
exports.PropertyAddressSuggestionsDtoToJSON = PropertyAddressSuggestionsDtoToJSON;
exports.PropertyAddressSuggestionsDtoToJSONTyped = PropertyAddressSuggestionsDtoToJSONTyped;
var SuggestionAddressComponents_1 = require("./SuggestionAddressComponents");
/**
 * Check if a given object implements the PropertyAddressSuggestionsDto interface.
 */
function instanceOfPropertyAddressSuggestionsDto(value) {
    if (!('address' in value) || value['address'] === undefined)
        return false;
    if (!('id' in value) || value['id'] === undefined)
        return false;
    if (!('addressComponents' in value) || value['addressComponents'] === undefined)
        return false;
    return true;
}
function PropertyAddressSuggestionsDtoFromJSON(json) {
    return PropertyAddressSuggestionsDtoFromJSONTyped(json, false);
}
function PropertyAddressSuggestionsDtoFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'address': json['address'],
        'id': json['id'],
        'addressComponents': (0, SuggestionAddressComponents_1.SuggestionAddressComponentsFromJSON)(json['addressComponents']),
    };
}
function PropertyAddressSuggestionsDtoToJSON(json) {
    return PropertyAddressSuggestionsDtoToJSONTyped(json, false);
}
function PropertyAddressSuggestionsDtoToJSONTyped(value, ignoreDiscriminator) {
    if (ignoreDiscriminator === void 0) { ignoreDiscriminator = false; }
    if (value == null) {
        return value;
    }
    return {
        'address': value['address'],
        'id': value['id'],
        'addressComponents': (0, SuggestionAddressComponents_1.SuggestionAddressComponentsToJSON)(value['addressComponents']),
    };
}
